import Icon from 'veui/components/Icon'

Icon.register({
  'folder-opened': {
    paths: [
      {
        d: 'M753.67 331.89A32 32 0 00728 319h-32v-95a32 32 0 00-32-32H369.13l-54.5-81.75A32 32 0 00288 96H64a32 32 0 00-32 32v544a32 32 0 0032 32h568a32 32 0 0030.66-22.83l96-321a32 32 0 00-4.99-28.28zM270.87 160l54.5 81.75A32 32 0 00352 256h280v63H160a32 32 0 00-30.66 22.83L96 453.32V160zm337.3 480H107l76.86-257H685z'
      }
    ],
    width: '768',
    height: '768'
  }
})
